import { ReactElement } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { MobileSupporterScreen } from './MobileSupporterScreen'
import { WebSupporterScreen } from './WebSupporterScreen'
import { URLS } from '../../content/urls'

export interface SupporterScreenData {
  fanImageUrl: string
  supporterLogoUrl: string
  supporterPremiumLogoUrl: string
}

const supporterScreenData: SupporterScreenData = {
  fanImageUrl: URLS.fanImage,
  supporterLogoUrl: URLS.supporterLogo,
  supporterPremiumLogoUrl: URLS.supporterPremiumLogo,
}

export const SupporterScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)

  return isMobile ? (
    <MobileSupporterScreen data={supporterScreenData} />
  ) : (
    <WebSupporterScreen data={supporterScreenData} />
  )
}
